export default __webpack_public_path__ + "static/media/banner_blog_8.2fa34032.jpg";